import React, { FunctionComponent, useEffect } from 'react'
import { View } from 'react-native'

import { useAnimateLottie } from '../../hooks/useAnimateLottie'
import { useLazyLottieSource } from '../../hooks/useLazyLottieSource'

export interface MovingBooksLottieProps {
  play?: boolean
  size?: number
  // in milliseconds
  duration?: number
}

export const MovingBooksLottie: FunctionComponent<MovingBooksLottieProps> = ({
  play = false,
  size = 158,
  duration = 700,
}) => {
  const { progress, playLottie, reverseLottie, AnimationView } = useAnimateLottie(duration)
  const animationData = useLazyLottieSource(() => import('../../assets/lottie/selfcare_books.json'))

  useEffect(() => {
    if (play) {
      playLottie()
    } else {
      reverseLottie()
    }
  }, [play, playLottie, reverseLottie])

  if (!animationData) {
    return <View style={{ height: size, width: size }} />
  }

  return <AnimationView source={animationData} progress={progress.current} style={{ height: size, width: size }} />
}
